module.exports = __webpack_public_path__ + "img/water-bilige-sensor.906cf483.svg";